import { withInstall } from '@hd-front-end/utils'
import Card from './src/card.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCard: SFCWithInstall<typeof Card> = withInstall(Card)
export default ElCard

export * from './src/card'
export type { CardInstance } from './src/instance'
